<script setup lang="ts">
    interface QuoteProps {
        data: QuoteData;
    }

    defineProps<QuoteProps>();
</script>

<template>
    <blockquote class="atm-quote mx-auto my-6 max-w-layout-md border-t-4 border-solid border-woom-red pt-14 text-woom-red max-md:mx-6">
        <p class="text-3xl font-bold md:text-4xl">
            <renderer-html :content="woomTextFormat(data.quote)" />
        </p>
        <footer class="mt-9 flex items-center gap-4">
            <atm-image
                v-if="data.portrait"
                :data="data.portrait"
                class="h-10 w-10 overflow-hidden rounded-full max-md:hidden"
                cover
                preset="1to1"
                sizes="1px md:80px" />
            <span
                v-if="data.subline"
                class="font-mono">
                <renderer-html :content="woomTextFormat(data.subline)" />
            </span>
        </footer>
    </blockquote>
</template>
